import globals, { vars as globalsVars } from './globals';
import components, { vars as componentsVars } from './components';

export const defaultTheme = { globals, components };
export const themeVars = { globals: globalsVars, components: componentsVars };
